import React from "react";
import { Alert, Card, Tabs, Typography } from "antd";
import { useSelection } from "../SelectionContext";
import { useConsolidatedTreasuryPermissions } from "./useConsolidatedTreasuryPermissions";
import LogisticsTreasuryAccounts from "../gestion-logistics/pages/LogisticsTreasuryAccounts";
import LogisticsTreasuryMovements from "../gestion-logistics/pages/LogisticsTreasuryMovements";

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const GestionTresorerieConsolidee = () => {
  const { selectedCompany, selectedWarehouse } = useSelection();
  const permissions = useConsolidatedTreasuryPermissions();
  const refreshKey = 0;

  if (!selectedCompany || !selectedWarehouse) {
    return (
      <Card>
        <Alert
          message="Selection requise"
          description="Selectionnez une entreprise et un établissement pour afficher la tresorerie consolidee."
          type="info"
          showIcon
        />
      </Card>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <Title level={3}>Tresorerie consolidee</Title>
        <Text type="secondary">
          Vue globale des comptes et des mouvements pour l'ensemble des modules.
        </Text>
      </div>

      <Tabs defaultActiveKey="accounts" type="card">
        {permissions.canViewTreasuryAccounts && (
          <TabPane tab="Comptes" key="accounts">
            <LogisticsTreasuryAccounts
              refreshKey={refreshKey}
              permissions={permissions}
              moduleScope="all"
            />
          </TabPane>
        )}
        {permissions.canViewTreasuryMovements && (
          <TabPane tab="Mouvements" key="movements">
            <LogisticsTreasuryMovements
              refreshKey={refreshKey}
              permissions={permissions}
              moduleScope="all"
            />
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};

export default GestionTresorerieConsolidee;
